<p-confirmDialog />

<div class="card">
  <!-- Stats row and filters stay put; only the content below them scrolls.
       The table already uses scrollHeight="flex", so it fills what's left. -->
  <div class="card-content card-content--fixed-header">
  <!-- Stats cards row (shared stats-cards styles) -->
  <div class="stats-cards-row">
    <div class="stats-card stats-card--total">
      <div class="stats-card-main">
        <span class="stats-card-value">{{ totalProjectsCount }}</span>
        <span class="stats-card-label">Total Projects</span>
        <span class="stats-card-sublabel">All projects</span>
      </div>
      <div class="stats-card-icon"><i class="pi pi-folder"></i></div>
    </div>
    <div class="stats-card stats-card--success">
      <div class="stats-card-main">
        <span class="stats-card-value">{{ activeProjectsCount }}</span>
        <span class="stats-card-label">Active</span>
        <span class="stats-card-sublabel">Currently active</span>
      </div>
      <div class="stats-card-icon"><i class="pi pi-check-circle"></i></div>
    </div>
    <div class="stats-card stats-card--danger">
      <div class="stats-card-main">
        <span class="stats-card-value">{{ inactiveProjectsCount }}</span>
        <span class="stats-card-label">Inactive</span>
        <span class="stats-card-sublabel">Not active</span>
      </div>
      <div class="stats-card-icon"><i class="pi pi-minus-circle"></i></div>
    </div>
    <div class="stats-card stats-card--total">
      <div class="stats-card-main">
        <span class="stats-card-value">{{ totalRecords }}</span>
        <span class="stats-card-label">Showing</span>
        <span class="stats-card-sublabel">After filters</span>
      </div>
      <div class="stats-card-icon"><i class="pi pi-list"></i></div>
    </div>
  </div>

  <!-- Filter bar (same structure as allocation: filter-bar, filter-bar-filters, filter-field, filter-label) -->
  <div class="filter-bar filter-bar-collapsible mb-4" [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
    <div class="filter-bar-filters">
      <div class="filter-field">
        <label for="statusFilter" class="filter-label">Status</label>
        <p-select id="statusFilter" [(ngModel)]="selectedStatusFilter" (ngModelChange)="applySearch()"
          [options]="statusFilterOptions" optionLabel="label" optionValue="value" placeholder="All"
          [showClear]="true" [filter]="true" filterPlaceholder="Search status..."
          panelStyleClass="filter-dropdown-panel" appendTo="body" />
      </div>
      <div class="filter-field">
        <label for="projectManagerFilter" class="filter-label">Project Manager</label>
        <p-select id="projectManagerFilter" [(ngModel)]="selectedProjectManagerFilter" (ngModelChange)="applySearch()"
          [options]="projectManagers" optionLabel="name" optionValue="id" placeholder="All"
          [showClear]="true" [filter]="true" filterPlaceholder="Search project manager..."
          panelStyleClass="filter-dropdown-panel" appendTo="body" />
      </div>
      <div class="filter-field">
        <label for="clientFilter" class="filter-label">Client</label>
        <p-select id="clientFilter" [(ngModel)]="selectedClientFilter" (ngModelChange)="applySearch()"
          [options]="clients" optionLabel="name" optionValue="id" placeholder="All"
          [showClear]="true" [filter]="true" filterPlaceholder="Search client..."
          panelStyleClass="filter-dropdown-panel" appendTo="body" />
      </div>
      <div class="filter-field">
        <label for="accountManagerFilter" class="filter-label">Account Manager</label>
        <p-select id="accountManagerFilter" [(ngModel)]="selectedAccountManagerFilter" (ngModelChange)="applySearch()"
          [options]="accountManagers" optionLabel="name" optionValue="id" placeholder="All"
          [showClear]="true" [filter]="true" filterPlaceholder="Search account manager..."
          panelStyleClass="filter-dropdown-panel" appendTo="body" />
      </div>
      <div class="filter-field">
        <label for="serviceGroupFilter" class="filter-label">Service Group</label>
        <p-select id="serviceGroupFilter" [(ngModel)]="selectedServiceGroupFilter" (ngModelChange)="applySearch()"
          [options]="serviceGroups" optionLabel="name" optionValue="id" placeholder="All"
          [showClear]="true" [filter]="true" filterPlaceholder="Search service group..."
          panelStyleClass="filter-dropdown-panel" appendTo="body" />
      </div>
    </div>
    <div class="filter-bar-actions">
      <button type="button" *ngIf="hasActiveFilters()" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
        <i class="pi pi-filter-slash"></i>
      </button>
      <!-- View toggles, matching the other project pages. -->
      <button type="button" class="view-toggle-icon"
              [class.active]="viewMode === 'table'"
              (click)="setViewMode('table')"
              pTooltip="Table view" tooltipPosition="top">
        <i class="pi pi-list"></i>
      </button>
      <button type="button" class="view-toggle-icon"
              [class.active]="viewMode === 'kanban'"
              (click)="setViewMode('kanban')"
              pTooltip="Kanban view (by progress)" tooltipPosition="top">
        <i class="pi pi-objects-column"></i>
      </button>
    </div>
  </div>

  <p-table
    *ngIf="viewMode === 'table'"
    [scrollable]="true"
    scrollHeight="flex"
    [value]="filteredProjects"
    [loading]="loading"
    [paginator]="true"
    [alwaysShowPaginator]="false"
    [rows]="rows"
    [totalRecords]="totalRecords"
    [first]="first"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} projects"
    [tableStyle]="{ 'width': '100%', 'table-layout': 'fixed' }"
    [resizableColumns]="true"
    columnResizeMode="expand"
    styleClass="p-datatable project-management-table no-column-lines resize-handles-visible">

    <ng-template pTemplate="colgroup">
      <colgroup>
        <col style="width: 12%">
        <col style="width: 8%">
        <col style="width: 13%">
        <col style="width: 8%">
        <col style="width: 12%">
        <col style="width: 12%">
        <col style="width: 9%">
        <col style="width: 10%">
        <col style="width: 9%">
        <col style="width: 7%">
      </colgroup>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th pResizableColumn pSortableColumn="name" class="th-project-name">
          Project Name
          <p-sortIcon field="name" />
        </th>
        <th pResizableColumn pSortableColumn="managerId" class="th-pm-am" pTooltip="Sort by Project Manager / Account Manager" tooltipPosition="top">
          PM/AM
          <p-sortIcon field="managerId" />
        </th>
        <th pResizableColumn pSortableColumn="invoiceType">
          Invoice Type
          <p-sortIcon field="invoiceType" />
        </th>
        <th pResizableColumn pSortableColumn="clientId">
          Client
          <p-sortIcon field="clientId" />
        </th>
        <th pResizableColumn pSortableColumn="serviceGroupId">
          Service Group
          <p-sortIcon field="serviceGroupId" />
        </th>
        <th pResizableColumn pSortableColumn="costCenterId">
          Cost Center
          <p-sortIcon field="costCenterId" />
        </th>
        <th pResizableColumn>Description</th>
        <th pResizableColumn pSortableColumn="startDate">
          Start Date
          <p-sortIcon field="startDate" />
        </th>
        <th pResizableColumn pSortableColumn="endDate">
          End Date
          <p-sortIcon field="endDate" />
        </th>
        <th pResizableColumn class="th-actions">Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-project>
      <tr [class.row-inactive]="project.isActive === false">
        <td class="td-project-name">
          <div class="project-name-cell" [pTooltip]="(project.name || '') + (project.projectCode ? ' (' + project.projectCode + ')' : '')" tooltipPosition="top">
            <span class="project-name-main">{{ project.name || '-' }}</span>
            <span class="project-code-sublabel">{{ project.projectCode || '-' }}</span>
          </div>
        </td>
        <td class="td-pm-am">
          <div class="pm-am-cell"
            [pTooltip]="'Project Manager: ' + (getManagerName(project.managerId) || '-') + '\nAccount Manager: ' + (getAccountManagerName(project.accountManagerId) || '-')"
            tooltipPosition="top">
            <span class="pm-am-name">{{ getManagerName(project.managerId) || '-' }}</span>
            <span class="pm-am-name pm-am-name--secondary">{{ getAccountManagerName(project.accountManagerId) || '-' }}</span>
          </div>
        </td>
        <td>
          <span *ngIf="project.invoiceType !== undefined && project.invoiceType !== null"
            class="invoice-type-badge invoice-type-badge--{{ getInvoiceTypeSeverity(project.invoiceType) }}">
            <i class="pi pi-circle-fill invoice-type-badge-dot" aria-hidden="true"></i>
            {{ getInvoiceTypeName(project.invoiceType) }}
          </span>
          <span *ngIf="project.invoiceType === undefined || project.invoiceType === null">-</span>
        </td>
        <td class="td-truncate" [pTooltip]="getClientName(project.clientId)" tooltipPosition="top">{{ getClientName(project.clientId) }}</td>
        <td class="td-truncate" [pTooltip]="getServiceGroupName(project.serviceGroupId)" tooltipPosition="top">{{ getServiceGroupName(project.serviceGroupId) }}</td>
        <td class="td-truncate" [pTooltip]="getCostCenterName(project.costCenterId)" tooltipPosition="top">{{ getCostCenterName(project.costCenterId) || '-' }}</td>
        <td class="td-truncate" [pTooltip]="project.description || '-'" tooltipPosition="top">{{ project.description || '-' }}</td>
        <td>{{ formatDate(project.startDate) }}</td>
        <td>{{ formatDate(project.endDate) }}</td>
        <td class="table-cell-actions">
          <div class="table-actions-stack">
            <p-button
              [icon]="project.isActive ? 'pi pi-check-circle' : 'pi pi-times-circle'"
              [severity]="project.isActive ? 'success' : 'secondary'"
              [text]="true"
              (onClick)="toggleActiveStatus(project)"
              size="small"
              [pTooltip]="project.isActive ? 'Active' : 'Inactive'"
              tooltipPosition="top" />
            <p-button
              icon="pi pi-pencil"
              (onClick)="showEditDialog(project)"
              [text]="true"
              severity="info"
              size="small"
              pTooltip="Edit"
              tooltipPosition="top" />
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr class="table-empty-row">
        <td colspan="9" class="table-empty-cell">
          <div class="empty-state">
            <div class="empty-icon"><i class="pi pi-inbox"></i></div>
            <p class="empty-message">No projects found</p>
            <p class="empty-description">Update filters or add a new project</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- ============ KANBAN VIEW (one column per progress state) ============
       Reuses the shared .kanban-* styles from styles/_presales.scss so this
       board matches the Project List and presales boards. -->
  <div *ngIf="viewMode === 'kanban'" class="kanban-view kanban-view--progress">
    <div class="empty-state" *ngIf="!loading && filteredProjects.length === 0">
      <div class="empty-icon"><i class="pi pi-inbox"></i></div>
      <p class="empty-message">No projects found</p>
      <p class="empty-description">Update filters or add a new project.</p>
    </div>

    <div class="kanban-scroll" *ngIf="filteredProjects.length > 0">
      <div class="kanban-grid">
        <div class="kanban-col" *ngFor="let col of visibleKanbanColumns"
             [ngClass]="col.cssClass"
             [class.is-empty]="col.projects.length === 0">
          <div class="kanban-col-head">
            <div class="kanban-col-head-top">
              <span class="kanban-col-title">
                <span class="dot" [ngClass]="col.cssClass"></span>{{ col.label }}
              </span>
              <span class="kanban-col-count">{{ col.projects.length }}</span>
            </div>
          </div>
          <div class="kanban-col-body">
            <div class="kanban-card kanban-card--rich"
                 *ngFor="let project of col.projects"
                 [ngClass]="'rag-' + getStatusSeverity(project.status)"
                 [class.is-inactive]="project.isActive === false"
                 [class.is-overdue]="calcOverdueDays(project.endDate)"
                 (click)="showEditDialog(project)">

              <!-- Row 1: RAG health, plus the active toggle this page owns. -->
              <div class="kanban-card-top">
                <span class="k-stage" [ngClass]="getStatusBadgeClass(project.status)">
                  {{ project.status || 'No status' }}
                </span>
                <!-- Active toggle stays reachable from the board; the card body
                     opens the edit dialog, so this stops the click bubbling. -->
                <button type="button" class="kanban-card-action"
                        (click)="toggleActiveStatus(project); $event.stopPropagation()"
                        [pTooltip]="project.isActive ? 'Active — click to deactivate' : 'Inactive — click to activate'"
                        tooltipPosition="top">
                  <i class="pi" [ngClass]="project.isActive ? 'pi-check-circle' : 'pi-times-circle'"></i>
                </button>
              </div>

              <h4 class="kanban-card-title" [pTooltip]="project.name" tooltipPosition="top"
                  [tooltipOptions]="{ showDelay: 600 }">{{ project.name || '-' }}</h4>

              <div class="kanban-card-meta">
                <span class="k-client" [pTooltip]="getClientName(project.clientId) || 'No client set'" tooltipPosition="top">
                  <i class="pi pi-building"></i>{{ getClientName(project.clientId) || 'No client set' }}
                </span>
                <span class="k-code" *ngIf="project.projectCode">{{ project.projectCode }}</span>
              </div>

              <!-- Effort against the planned estimate — the delivery equivalent
                   of the presales card's deal value and win bar. -->
              <div class="kanban-card-value" *ngIf="effortPct(project) !== null">
                <span class="k-money">
                  {{ project.actualEffortDays || 0 }}<span class="cur">/{{ project.plannedEstimateDays }}d</span>
                </span>
                <span class="k-win" [class.k-win--over]="effortPct(project)! > 100"
                      [pTooltip]="'Effort used against planned estimate'" tooltipPosition="top">
                  <span class="k-win-bar"><span class="k-win-fill"
                        [style.width.%]="effortBarPct(project)"></span></span>
                  {{ effortPct(project) }}%
                </span>
              </div>

              <div class="kanban-card-foot">
                <span class="k-owner" [pTooltip]="'Manager: ' + (getManagerName(project.managerId) || 'Unassigned')"
                      tooltipPosition="top">
                  <span class="k-avatar" [style.--k-hue]="avatarHue(getManagerName(project.managerId))">{{ initials(getManagerName(project.managerId)) }}</span>
                  <span class="k-owner-name">{{ getManagerName(project.managerId) || 'Unassigned' }}</span>
                </span>
                <span class="k-close k-overdue" *ngIf="calcOverdueDays(project.endDate) as od">
                  <i class="pi pi-exclamation-circle"></i>{{ od }}d over
                </span>
                <span class="k-close" *ngIf="!calcOverdueDays(project.endDate) && project.endDate"
                      [class.k-close--soon]="isEndingSoon(project.endDate)"
                      [pTooltip]="'Ends: ' + shortDate(project.endDate)" tooltipPosition="top">
                  <i class="pi pi-calendar"></i>{{ endLabel(project.endDate) }}
                </span>
              </div>
            </div>
            <div class="kanban-empty" *ngIf="col.projects.length === 0">No projects</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</div>

<p-dialog [visible]="displayDialog" (visibleChange)="displayDialog = $event"
  [header]="isEditMode ? 'Edit Project' : 'Add Project'"
  [modal]="true" styleClass="dialog-lg project-form-dialog" [dismissableMask]="true" [closable]="true">

  <div class="form-dialog-form form-dialog-compact">
    <div class="form-dialog-container">
      <div class="form-row two-columns">
        <div class="field">
          <label for="projectCode">Project Code</label>
          <input pInputText id="projectCode" [(ngModel)]="selectedProject.projectCode"
            placeholder="Enter project code (e.g., BID-03610)" />
        </div>
        <div class="field" [class.field-invalid]="fieldTouched['name'] && !selectedProject.name.trim()">
          <label for="name">Project Name <span class="required-star">*</span></label>
          <div class="flex align-items-center gap-2">
            <input pInputText id="name" [(ngModel)]="selectedProject.name"
              (blur)="fieldTouched['name'] = true"
              placeholder="Enter project name" required class="flex-1" />
            <div class="flex align-items-center gap-2 flex-shrink-0">
              <p-checkbox id="isAvailableToAllEmployees" [(ngModel)]="selectedProject.isAvailableToAllEmployees"
                [binary]="true" />
              <label for="isAvailableToAllEmployees" class="cursor-pointer text-nowrap text-sm">Available to all</label>
            </div>
          </div>
          <small class="field-error" *ngIf="fieldTouched['name'] && !selectedProject.name.trim()">Project name is required</small>
        </div>
      </div>

      <div class="form-row two-columns">
        <div class="field" [class.field-invalid]="fieldTouched['managerId'] && !selectedProject.managerId">
          <label for="manager">Project Manager <span class="required-star">*</span></label>
          <p-select id="manager" [(ngModel)]="selectedProject.managerId" [options]="projectManagers"
            optionLabel="name" optionValue="id" placeholder="Select a project manager"
            (onBlur)="fieldTouched['managerId'] = true"
            [filter]="true" [showClear]="true" panelStyleClass="filter-dropdown-panel" appendTo="body">
            <ng-template #empty>
              <div class="empty-message-text">No project managers found.</div>
            </ng-template>
          </p-select>
          <small class="field-error" *ngIf="fieldTouched['managerId'] && !selectedProject.managerId">Project manager is required</small>
        </div>
        <div class="field" [class.field-invalid]="fieldTouched['invoiceType'] && (selectedProject.invoiceType === undefined || selectedProject.invoiceType === null)">
          <label for="invoiceType">Invoicing Type <span class="required-star">*</span></label>
          <p-select id="invoiceType" [(ngModel)]="selectedProject.invoiceType" [options]="invoiceTypeOptions"
            optionLabel="label" optionValue="value" placeholder="Select invoicing type" [showClear]="false"
            (onBlur)="fieldTouched['invoiceType'] = true"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
          <small class="field-error" *ngIf="fieldTouched['invoiceType'] && (selectedProject.invoiceType === undefined || selectedProject.invoiceType === null)">Invoicing type is required</small>
        </div>
      </div>

      <div class="form-row two-columns">
        <div class="field">
          <label for="client">Client</label>
          <p-autocomplete id="client" [(ngModel)]="clientSearchText" [suggestions]="filteredClients"
            (completeMethod)="searchClient($event)" (onSelect)="onClientSelect($event)"
            (onClear)="onClientClear()" [dropdown]="true" optionLabel="name"
            placeholder="Type or select client" [forceSelection]="false" [showClear]="true"
            [showEmptyMessage]="false" [completeOnFocus]="false"
            styleClass="w-full" [style]="{width: '100%'}"
            panelStyleClass="filter-dropdown-panel" appendTo="body">
            <ng-template let-client pTemplate="item">
              <div class="ac-option-text" [pTooltip]="client.name" tooltipPosition="top">{{ client.name }}</div>
            </ng-template>
          </p-autocomplete>
        </div>
        <div class="field">
          <label for="accountManager">Account Manager</label>
          <p-select id="accountManager" [(ngModel)]="selectedProject.accountManagerId"
            [options]="accountManagers" optionLabel="name" optionValue="id"
            placeholder="Select an account manager" [filter]="true" [showClear]="true"
            panelStyleClass="filter-dropdown-panel" appendTo="body">
            <ng-template #empty>
              <div class="empty-message-text">No account managers found.</div>
            </ng-template>
          </p-select>
        </div>
      </div>

      <div class="form-row two-columns">
        <div class="field">
          <label for="serviceGroup">Service Group</label>
          <p-select id="serviceGroup" [(ngModel)]="selectedProject.serviceGroupId" [options]="serviceGroups"
            optionLabel="name" optionValue="id" placeholder="Select a service group"
            [filter]="true" [showClear]="true" panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="field">
          <label for="costCenter">Cost Center</label>
          <p-autocomplete id="costCenter" [(ngModel)]="costCenterSearchText" [suggestions]="filteredCostCenters"
            (completeMethod)="searchCostCenter($event)" (onSelect)="onCostCenterSelect($event)"
            (onClear)="onCostCenterClear()" [dropdown]="true" optionLabel="name"
            placeholder="Type or select cost center" [forceSelection]="false" [showClear]="true"
            [showEmptyMessage]="false" [completeOnFocus]="false"
            styleClass="w-full" [style]="{width: '100%'}"
            panelStyleClass="filter-dropdown-panel" appendTo="body">
            <ng-template let-costCenter pTemplate="item">
              <div class="ac-option-text" [pTooltip]="costCenter.name" tooltipPosition="top">{{ costCenter.name }}</div>
            </ng-template>
          </p-autocomplete>
        </div>
      </div>

      <div class="form-row two-columns">
        <div class="field">
          <label for="paymentTermDays" pTooltip="Days the customer has to pay after an invoice is released. Used to calculate each payment milestone's due date." tooltipPosition="top">Payment Term (Days)</label>
          <input type="number" id="paymentTermDays" class="p-inputtext"
            [(ngModel)]="selectedProject.paymentTermDays"
            placeholder="e.g. 30" min="1" max="3650" step="1" />
          <small class="field-hint">Leave blank if invoices for this project have no agreed payment period.</small>
        </div>
        <div class="field">
          <!-- spacer -->
        </div>
      </div>

      <div class="form-row">
        <div class="field">
          <label for="description">Description</label>
          <textarea id="description" [(ngModel)]="selectedProject.description" rows="3"
            class="p-inputtext" placeholder="Enter project description"></textarea>
        </div>
      </div>

      <div class="form-row two-columns">
        <div class="field">
          <label for="startDate">Start Date <span class="required-star">*</span></label>
          <p-datepicker inputId="startDate" [(ngModel)]="selectedStartDate" [showIcon]="true"
            dateFormat="D, M d, yy" placeholder="Select start date"
            [showOnFocus]="false" [autoZIndex]="true" appendTo="body" />
        </div>
        <div class="field" [class.field-invalid]="fieldTouched['endDate'] && selectedEndDate && selectedStartDate && selectedEndDate < selectedStartDate">
          <label for="endDate">End Date</label>
          <p-datepicker inputId="endDate" [(ngModel)]="selectedEndDate" [showIcon]="true"
            dateFormat="D, M d, yy" placeholder="Select end date (optional)" [showClear]="true"
            [showOnFocus]="false" [autoZIndex]="true" appendTo="body" />
          <small class="field-error" *ngIf="fieldTouched['endDate'] && selectedEndDate && selectedStartDate && selectedEndDate < selectedStartDate">End date must be after start date</small>
        </div>
      </div>

      <div class="form-row" *ngIf="isEditMode">
        <div class="field">
          <label>Status</label>
          <p-button [label]="selectedProject.isActive ? 'Active' : 'Inactive'"
            [severity]="selectedProject.isActive ? 'success' : 'secondary'"
            [outlined]="!selectedProject.isActive"
            (onClick)="selectedProject.isActive = !selectedProject.isActive" size="small" />
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Reset" icon="pi pi-refresh" (onClick)="resetProjectForm()"
        severity="secondary" [text]="true" styleClass="btn-form-reset" />
      <p-button label="Cancel" icon="pi pi-times" (onClick)="hideDialog()"
        severity="secondary" [outlined]="true" />
      <p-button label="Save" icon="pi pi-check" (onClick)="saveProject()" severity="primary" />
    </div>
  </ng-template>
</p-dialog>

